import { message, Space, Upload as AntUpload, List } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import ResponsiveCard from '../../components/ResponsiveCard';
import { uploadFile } from '../../api/resume';
import useFetchFiles from './hooks/fetch-files';

const { Dragger } = AntUpload;

async function customRequest({ file, onSuccess, onError }) {
  const hide = message.loading('ファイルをアップロードしています');

  try {
    if (file.size > 2000000) {
      message.error('ファイルサイズが大きすぎます');
      return false;
    }
    await uploadFile(file);
    onSuccess();
  } catch (e) {
    onError();
  } finally {
    hide();
  }
}

function onChange(info, pageChange) {
  if (info.file.status === 'done') {
    message.success('ファイルがアップロードされました');
    pageChange(1);
  }

  if (info.file.status === 'error') {
    message.error('ファイルのアップロードに失敗しました');
  }
}

export default function Upload({ onError }) {
  const { files, pageChange, filesLoading } = useFetchFiles({
    onError,
  });

  return (
    <>
      <p>
        職務経歴書は、こちらからアップロードすることができます。
        <br />
        ※1ファイルずつアップロードしてください。
      </p>
      <div>
        <Space direction="vertical" className="fluid" size="middle">
          <Dragger
            name="file"
            showUploadList={false}
            customRequest={customRequest}
            onChange={info => onChange(info, pageChange)}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined />
            </p>
            <p className="ant-upload-text">
              クリックしてファイルを選択するか、ファイルをドラッグ＆ドロップしてください。
            </p>
            <p className="ant-upload-hint">
              アップロードできるファイルは2MBまでです。
            </p>
          </Dragger>

          <ResponsiveCard className="raised" title="更新履歴">
            <p>本ページからの最新5件の更新履歴のみが表示されています。</p>
            <List
              bordered
              dataSource={files}
              loading={filesLoading}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={item.fileName}
                    description={`${item.registrationDate} 登録`}
                  />
                </List.Item>
              )}
            />
          </ResponsiveCard>
        </Space>
      </div>
    </>
  );
}
